import React, { useEffect, useState } from 'react';
import styled from 'styled-components';

// Components
import { Radar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
} from 'chart.js';

ChartJS.register(
    RadialLinearScale,
    PointElement,
    LineElement,
    Filler,
    Tooltip,
    Legend
);

const ChartModal = ({ isOpen, onClose, attributes }) => {
    
    const data = {
        labels: attributes?.map(item => item?.name),
        datasets: [
            {
                label: '',
                data: attributes?.map(item => item?.score),
                backgroundColor: 'rgba(255, 99, 132, 0.2)',
                borderColor: 'rgba(255, 99, 132, 1)',
                borderWidth: 1,
            },
        ],
    };
    
    const options = {
        scales: {
            r: {
                beginAtZero: true,
                min: 0,
                max: 5
            }
        }
    };
    if (!isOpen) return null;
    return (
        <ModalOverlay>
            <ModalBackdrop onClick={onClose} />

            <ModalContainer>
                <ModalHeader>
                    <ModalTitle>
                        Análisis general
                    </ModalTitle>
                    <CloseButton onClick={onClose}>
                        {/* Cambiar a icono de FontAwesome */}
                        <svg width="24" height="24" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </CloseButton>
                </ModalHeader>

                <ModalBody>
                    <Radar data={data} options={options} />
                </ModalBody>
            </ModalContainer>
        </ModalOverlay>
    );
};

export default ChartModal;

const ModalOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 999999999;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ModalBackdrop = styled.div`
    position: fixed;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.5);
    transition: opacity 0.3s ease;
`;

const ModalContainer = styled.div`
    position: relative;
    background-color: white;
    border-radius: 20px;
    width: 60vw;
    height: 90vh;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: center;
    gap: 0 !important;
    box-shadow: 0px 12px 24px -15px #0000001A, 0px 0px 10px -6px #00000040;

`;

const ModalHeader = styled.div`
    position: relative;
    width: calc(100% - 2rem);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem;
    border-bottom: 1px solid #e5e7eb;
    background-color: #b31d15;
    border-radius: 20px 20px 0 0;
`;

const ModalTitle = styled.h3`
    font-size: 1.25rem;
    font-weight: 600;
    color: #fff;
`;

const CloseButton = styled.button`
    cursor: pointer;
    position: absolute;
    top: 1rem;
    right: 1rem;
    color: #FFF !important;
    background-color: transparent !important;
    border: none;
    padding: 0;
    &:hover {
        color: #6b7280;
    }
    &:focus {
        outline: none;
    }
`;

const ModalBody = styled.div`
    width: 30vw;
    height: 100%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;